// extracted by mini-css-extract-plugin
export default {"subs-header":"subs-header--_Yxrp"};
    if(module.hot) {
      // 1747648133058
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  